
import { cartCount } from '../api/API/shoppingCart'
// 获取购物车数量
export const getCart = ({ commit, state }) => {
    var list = {
        mod: "inc",
        act: "ordersys",
        str: "cartCount",
        token: ""
    };
    if (localStorage.getItem('token')) {
        list.token = localStorage.getItem("token");
        cartCount(list)
            .then(res => {
                commit('shoppingTotal', res.data.cartCount)
            });
    } else {
        commit('shoppingTotal', '')
    }
}